import { Preferences } from "@capacitor/preferences";
import { FirebaseMessaging } from "@capacitor-firebase/messaging";

export const NOTIFICATION_TOKEN_KEY = "notification_token";

const checkPermissions = async () => {
  const result = await FirebaseMessaging.checkPermissions();
  return result.receive;
};

const requestPermissions = async () => {
  const result = await FirebaseMessaging.requestPermissions();
  return result.receive;
};

const getToken = async () => {
  const result = await FirebaseMessaging.getToken();
  return result.token;
};

const deleteToken = async () => {
  await FirebaseMessaging.deleteToken();
};

export const registerNotifications = async () => {
  let permissionStatus = await checkPermissions();

  if (permissionStatus === "prompt") {
    permissionStatus = await requestPermissions();
  }

  if (permissionStatus !== "granted") {
    return null;
  }

  return await getToken();
};

export const unregisterNotifications = async () => {
  try {
    const { value: localNotificationToken } = await Preferences.get({
      key: NOTIFICATION_TOKEN_KEY,
    });

    await deleteToken();

    await Preferences.remove({ key: NOTIFICATION_TOKEN_KEY });

    return localNotificationToken;
  } catch {
    return null;
  }
};
